import api from './api';

const paymentTermService = {
  // Get all payment terms
  getPaymentTerms: async () => {
    try {
      const response = await api.get('/payment-terms');
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Failed to fetch payment terms' };
    }
  },

  // Create a new payment term
  createPaymentTerm: async (paymentTermData) => {
    try {
      const response = await api.post('/payment-terms', paymentTermData);
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Failed to create payment term' };
    }
  },

  // Update a payment term
  updatePaymentTerm: async (id, paymentTermData) => {
    try {
      const response = await api.put(`/payment-terms/${id}`, paymentTermData);
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Failed to update payment term' };
    }
  },

  // Delete a payment term
  deletePaymentTerm: async (id) => {
    try {
      const response = await api.delete(`/payment-terms/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Failed to delete payment term' };
    }
  },

  // Initialize default payment terms
  initializeDefaults: async () => {
    try {
      const response = await api.post('/payment-terms/initialize-defaults');
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Failed to initialize default payment terms' };
    }
  }
};

export default paymentTermService;

